import React, {useState} from 'react';
import {K} from '@henrybuilt/react-lib';

const ScrollableNote = ({propNotes, style, onChange}) => {
  const [notes, setNotes] = useState(propNotes);
  const [isInitialFocus, setIsInitialFocus] = useState(true);
  const [isFocused, setIsFocused] = useState(false);
  const textareaRef = React.useRef(null);

  const styles = {
    note: {
      padding: K.spacing / 2,
      width: '100%',
      border: 'none',
      outline: 'none',
      fontFamily: 'sans-serif',
      letterSpacing: 2,
      ...style
    },
  };

  const handleNotesChange = (event) => {
    const updatedNotes = event.target.value;

    setNotes(updatedNotes);

    onChange?.(updatedNotes);
  };

  const bullet = '\u2022';
  const bulletWithSpace = `${bullet} `;
  const enterKeyCode = 13;

  const handleKeyDown = async (event) => {
    const {keyCode, target} = event;
    const {selectionStart, value} = target;

    if (keyCode === enterKeyCode) {
      event.preventDefault();

      target.value = [...value]
        .map((c, i) => i === selectionStart - 1
          ? `${c}\n${bulletWithSpace}`
          : c
        )
        .join('');

      target.selectionStart = selectionStart + bulletWithSpace.length + 1;
      target.selectionEnd = selectionStart + bulletWithSpace.length + 1;
    }

    if (value[0] !== bullet) {
      target.value = `${bulletWithSpace}${value}`;
    }
  };

  const handleFocus = () => {
    if (!isInitialFocus) setIsInitialFocus(false);
    if (!isFocused) setIsFocused(true);
  };

  const handleBlur = (event) => {
    if (isFocused) setIsFocused(false);

    if (event.target.value === bulletWithSpace) event.target.value = '';

    handleNotesChange(event);
  };

  React.useLayoutEffect(() => {
    textareaRef.current.style.height = 'inherit';
    textareaRef.current.style.height = `${Math.max(
      textareaRef.current.scrollHeight,
      K.spacing * 2
    )}px`;
  }, [notes]);

  const getFormattedNotes = (notes) => {
    let updatedNotes = notes;

    if (isInitialFocus && isFocused && updatedNotes[0] !== bullet) {
      updatedNotes = `${bulletWithSpace}${updatedNotes}`;
    }

    return updatedNotes;
  };

  return (
    <textarea
      style={{
        minHeight: K.spacing * 2,
        resize: 'none',
        display: 'list-item',
        outline: 'none',
        overflowY: 'hidden',
        ...styles.note,
      }}
      ref={textareaRef}
      onInput={handleNotesChange}
      onBlur={handleBlur}
      placeholder={'Leave notes...'}
      data-no-dnd={true}
      value={getFormattedNotes(notes)}
      onKeyDown={handleKeyDown}
      onFocus={handleFocus}
    />
  );
};

export default ScrollableNote;
